const modulePages = [
	{
		id: 'm8-page-1',
		isFacilitatorOnly: true,
		title: 'OPFØLGNING PÅ LANGSIGTET BASALPLAN',
		facilitatorText: null,
		groupText: null,
		icons: [],
		slides: [
			{
				id: 'm8-ovelse',
				type: 'image', 
				text: 'ØVELSE'
			},
		]	
	},
	{
		id: 'm8-page-2',
		isFacilitatorOnly: true,
		title: 'BASALQUIZ',
		facilitatorText: null,
		icons: [],
		// downloads: [{
		// 	title: 'BASALQUIZ',
		// 	file: 'm8-basalquiz.pdf'
		// }],
		slides: [
			{
				id: 'm8-send-aben-videre',
				type: 'image',
				text: 'SEND ABEN VIDERE'
			},
			{
				id: 'm8-basalquiz-1',
				type: 'image',
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-2',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-3',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-4',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-5',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-6',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-7',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-8',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-9',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-10',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-11',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-12',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-13',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-14',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-15',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-16',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-17',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-18',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-19',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-20',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-21',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-22',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-23',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-24',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-25',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-26',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-27',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			},
			{
				id: 'm8-basalquiz-28',
				type: 'image',
				hideButton: true,
				text: 'BASALQUIZ'
			}	
		]	
	},
	{
		id: 'm8-page-3',
		isFacilitatorOnly: true,
		title: 'KLASSENS PLANER',
		facilitatorText: null,
		groupText: null,
		icons: [],
		slides: [
			{
				id: 'm8-ovelse-1',
				type: 'image',
				text: 'ØVELSE 1'
			},
			{
				id: 'm8-ovelse-2',
				type: 'image',
				text: 'ØVELSE 2'
			},
		]
	},
];


export {
	modulePages
};